import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import AspectRatio from 'components/ui/AspectRatio'
import WistiaEmbed from 'components/ui/WistiaEmbed'

import s from './VideoSlice.module.scss'

const cn = classNames.bind(s)

const WISTIA = 'Wistia'
const YOUTUBE = 'YouTube'
const VIMEO = 'Vimeo'

const VideoSlice = ({ data }) => {
  const { primary } = data

  if (!primary) return null

  const { embed_id, embed_platform } = primary
  let { ratio } = primary

  if (!ratio) {
    ratio = 16 / 9
  }

  return (
    <div className={cn('container')}>
      <div className={cn('wrapper')}>
        {embed_platform === YOUTUBE && (
          <div className={cn('videoWrapper')}>
            <iframe
              src={`https://www.youtube.com/embed/${embed_id}?autoplay=1&mute=1&loop=1&playlist=${embed_id}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {embed_platform === VIMEO && (
          <div className={cn('videoWrapper')}>
            <iframe
              src={`https://player.vimeo.com/video/${embed_id}?h=f7635d145a&autoplay=1&muted=1&loop=1`}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {embed_platform === WISTIA && (
          <AspectRatio ratio={parseFloat(ratio)}>
            <WistiaEmbed
              id={embed_id}
              initialState="playing"
              options={{ fullscreenButton: true, silentAutoPlay: true, endVideoBehavior: 'loop' }}
            />
          </AspectRatio>
        )}
      </div>
    </div>
  )
}

VideoSlice.propTypes = {
  data: PropTypes.object.isRequired,
}

export default VideoSlice
